import { call } from "../core";

export const callGetCrossSells = () => {
  return call("/cross-sells", "GET", {});
};

export const callBuyCrossSell = (id: string) => {
  return call(`/cross-sells/${id}`, 'POST', {})
}